import queryString from 'query-string'
import apiV2 from '.'

export const settingsFoApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getSettingsFo: builder.query({
      query: ({ eventId, domainId, filters, app, type }) =>
        `/settings/fo?${queryString.stringify({ eventId, domainId, filters, app, type })}`,
      transformResponse: response => response.data,
      providesTags: ['SETTINGS_FO'],
    }),
    updateSettingsFo: builder.mutation({
      query: ({ eventId, domainId, extended, languageId }) => ({
        url: `/settings/fo`,
        method: 'PUT',
        body: { eventId, domainId, extended, languageId },
      }),
      invalidatesTags: ['SETTINGS_FO'],
    }),
    addSettingsTag: builder.mutation({
      query: ({ tagId, settingsId, label, category }) => ({
        url: `/settings/fo/tags`,
        method: 'PUT',
        body: { tagId, settingsId, label, category },
      }),
      invalidatesTags: ['SETTINGS_FO'],
    }),
    removeSettingsTag: builder.mutation({
      query: ({ tagId, settingsId }) => ({
        url: `/settings/fo/tags`,
        method: 'DELETE',
        body: { tagId, settingsId },
      }),
      invalidatesTags: ['SETTINGS_FO'],
    }),
  }),
})

export const { useGetSettingsFoQuery, useUpdateSettingsFoMutation, useAddSettingsTagMutation, useRemoveSettingsTagMutation } = settingsFoApi
